module.exports = ".form-group.modal-question-top > label,\n.col-md-12.col-xs-12.col-sm-12 > p.h5 {\n\twhite-space: pre-line;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/answer_component/answer.component.css
// module id = ./src/app/component/shared/answer_component/answer.component.css
// module chunks = main